import { MessageCircle, Mail, Globe, Phone, Instagram, Youtube, MapPin } from "lucide-react";
import { waLink, WHATSAPP_DISPLAY, CONTACTS, EMAILS, INSTAGRAM_URL, YOUTUBE_URL, OFFICE_ADDRESS, scrollToId } from "../constants/site";

export const Footer = () => (
  <footer data-testid="footer" className="border-t border-white/10 bg-obsidian px-6 py-16 md:px-10">
    <div className="mx-auto grid max-w-7xl gap-12 md:grid-cols-3">
      <div>
        <div className="flex items-center gap-3">
          <img src="/assets/gautam-logo.png" alt="Gautam Travel logo" data-testid="footer-logo-img" className="h-12 w-auto" />
          <p className="font-display text-3xl">
            Gautam<span className="italic text-sunset">Travel</span>
          </p>
        </div>
        <p className="mt-4 max-w-xs text-sm font-light leading-relaxed text-white/50">
          Journeys, holidays and visas crafted with trust since 2014. 1000+ approvals and counting.
        </p>
      </div>

      <div>
        <p className="text-xs uppercase tracking-[0.3em] text-white/40">Explore</p>
        <div className="mt-5 flex flex-col gap-3">
          {[
            { label: "Destinations", href: "#destinations", testid: "footer-link-destinations" },
            { label: "Visa Services", href: "#visas", testid: "footer-link-visas" },
            { label: "Pay Securely", href: "#pay", testid: "footer-link-pay" },
            { label: "Contact", href: "#contact", testid: "footer-link-contact" },
          ].map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => scrollToId(e, l.href)}
              data-testid={l.testid}
              className="w-fit text-sm text-white/60 transition-colors duration-300 hover:text-sunset"
            >
              {l.label}
            </a>
          ))}
        </div>
      </div>

      <div>
        <p className="text-xs uppercase tracking-[0.3em] text-white/40">Reach Us</p>
        <div className="mt-5 flex flex-col gap-3 text-sm text-white/60">
          <a href={waLink()} target="_blank" rel="noreferrer" data-testid="footer-whatsapp-link" className="flex w-fit items-center gap-3 transition-colors duration-300 hover:text-teal">
            <MessageCircle className="h-4 w-4 text-teal" /> {WHATSAPP_DISPLAY}
          </a>
          {CONTACTS.map((c) => (
            <a
              key={c.tel}
              href={`tel:${c.tel}`}
              data-testid={`footer-phone-${c.tel}`}
              className="flex w-fit items-start gap-3 transition-colors duration-300 hover:text-sunset"
            >
              <Phone className="mt-0.5 h-4 w-4 shrink-0 text-sunset" />
              <span>
                <span className="block text-[11px] uppercase tracking-[0.2em] text-white/35">{c.label}</span>
                {c.phone}
              </span>
            </a>
          ))}
          {EMAILS.map((email) => (
            <a
              key={email}
              href={`mailto:${email}`}
              data-testid={`footer-email-${email}`}
              className="flex w-fit items-center gap-3 transition-colors duration-300 hover:text-sunset"
            >
              <Mail className="h-4 w-4 text-sunset" /> {email}
            </a>
          ))}
          <span className="flex items-start gap-3" data-testid="footer-office-address">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-teal" />
            <span>{OFFICE_ADDRESS}</span>
          </span>
          <span className="flex items-center gap-3">
            <Globe className="h-4 w-4 text-coral" /> gautamtravel.site
          </span>
          <div className="mt-2 flex items-center gap-4">
            <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" data-testid="footer-instagram-link" aria-label="Instagram" className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white/60 transition-colors duration-300 hover:border-[#dd2a7b] hover:text-[#dd2a7b]">
              <Instagram className="h-4 w-4" />
            </a>
            <a href={YOUTUBE_URL} target="_blank" rel="noreferrer" data-testid="footer-youtube-link" aria-label="YouTube" className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white/60 transition-colors duration-300 hover:border-[#ff4444] hover:text-[#ff4444]">
              <Youtube className="h-4 w-4" />
            </a>
          </div>
        </div>
      </div>
    </div>

    <div className="mx-auto mt-14 flex max-w-7xl flex-col gap-3 border-t border-white/10 pt-8 text-xs text-white/35 md:flex-row md:items-center md:justify-between">
      <p>© 2026 Gautam Travel. All rights reserved.</p>
      <p className="uppercase tracking-[0.3em]">Est. 2014 · Pehowa, Haryana, India</p>
    </div>
  </footer>
);
